const migrate0000 = state => ({ knownClasses: state.knownClasses });
export default migrate0000;
